import React from 'react';
import type { ChatMessage } from '@/types/chat';
import MindMentionText from '../ChatInput/MindMentionText';

interface UserBubbleProps {
  message: ChatMessage;
}

const UserBubble: React.FC<UserBubbleProps> = ({ message }) => {
  return (
    <div className="msg-user-row">
      <div className="msg-user-bubble">
        <MindMentionText text={message.content.text ?? ''} />
      </div>
    </div>
  );
};

export default UserBubble;
